import { decrypted } from "@/plugins/crypto";
export function readStoredMemberships() {
    const storedMemberships = localStorage.getItem("memberships");
    if (!storedMemberships)
        return [];
    try {
        const parsed = decrypted(storedMemberships);
        return Array.isArray(parsed) ? parsed : [];
    }
    catch {
        return [];
    }
}
export function shouldRedirectSingleOrgSelector() {
    const selectedOrgId = localStorage.getItem("org_id");
    if (!selectedOrgId)
        return false;
    const selectedRoleKey = localStorage.getItem("role_key");
    const activeMemberships = readStoredMemberships().filter((membership) => membership.org_status !== "inactive" && membership.is_active !== false);
    if (activeMemberships.length !== 1)
        return false;
    const [membership] = activeMemberships;
    return (String(membership.org_id) === selectedOrgId &&
        (!selectedRoleKey || membership.role_key === selectedRoleKey));
}
